import { useState } from 'react';
import type { FormEvent } from 'react';

const perks = [
  '每周一次精选：新增档案与重要更正一并汇总',
  '只发与人物黑料、黑历史归档相关的整理内容',
  '随时退订，邮箱仅用于速递发送，不做他用',
];

const focusOptions = ['全部速递', '综艺争议', '直播风波', '版权纠纷', '情感爆料'];

type Status = 'idle' | 'loading' | 'success' | 'error';

export default function SubscribeSection() {
  const [status, setStatus] = useState<Status>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const trap = String(formData.get('contact_alt') ?? '').trim();
    if (trap) {
      setStatus('success');
      return;
    }
    formData.delete('contact_alt');

    setStatus('loading');
    setFormError('');

    try {
      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        body.append(key, String(value));
      });

      const response = await fetch('https://readdy.ai/api/form/daim6troh653ivfvog3g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText) as Record<string, unknown>;
      } catch {
        parsed = null;
      }

      const meta = (parsed?.meta ?? null) as Record<string, unknown> | null;
      const rawServerMsg =
        (meta?.message as string) ||
        (parsed?.message as string) ||
        (meta?.detail as string) ||
        responseText ||
        '';
      const code = (parsed?.code as string) || '';
      const isSpam = rawServerMsg.toLowerCase().includes('spam');

      if (response.ok && code === 'OK' && !isSpam) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setFormError(
          isSpam ? '提交被拦截了，请稍后再试一次。' : rawServerMsg || '提交失败，请稍后再试。'
        );
      }
    } catch {
      setStatus('error');
      setFormError('网络好像不太稳定，请稍后再试。');
    }
  };

  return (
    <section id="subscribe" className="scroll-mt-20 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8 xl:px-10">
        <div className="grid grid-cols-1 overflow-hidden rounded-lg border border-background-200 lg:grid-cols-12">
          <div className="bg-background-50 p-6 md:p-8 lg:col-span-7">
            <span className="inline-flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-primary-400" />
              Newsletter
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[30px]">
              订阅黑料速递
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              不想天天刷？把新增档案、重要更正和信源补充打包成一份速递，每周送到你的邮箱。
            </p>
            <ul className="mt-6 flex flex-col gap-3">
              {perks.map((perk) => (
                <li key={perk} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center text-accent-600">
                    <i className="ri-checkbox-circle-line text-base" />
                  </span>
                  {perk}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-primary-500 p-6 md:p-8 lg:col-span-5">
            <h3 className="font-heading text-base font-bold text-background-50 md:text-lg">
              留下邮箱，开始接收速递
            </h3>
            <p className="mt-2 text-xs leading-relaxed text-background-50/85">
              填写后即表示同意接收速递邮件，可随时退订。
            </p>

            {status === 'success' ? (
              <div className="mt-5 flex items-start gap-3 rounded-md bg-background-50 px-4 py-4">
                <span className="flex h-6 w-6 shrink-0 items-center justify-center text-primary-600">
                  <i className="ri-checkbox-circle-fill text-xl" />
                </span>
                <div>
                  <p className="font-label text-sm font-medium text-foreground-950">订阅成功</p>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                    已记录你的订阅信息，下一期速递会发送到你的邮箱。
                  </p>
                </div>
              </div>
            ) : (
              <form
                id="hlw-subscribe-form"
                data-readdy-form
                onSubmit={handleSubmit}
                className="mt-5 flex flex-col gap-3"
              >
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="hlw-focus" className="font-label text-xs text-background-50/90">
                    关注方向
                  </label>
                  <select
                    id="hlw-focus"
                    name="focus"
                    defaultValue={focusOptions[0]}
                    className="w-full cursor-pointer rounded-md border border-background-50/30 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none focus:border-background-50"
                  >
                    {focusOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-col gap-1.5">
                  <label htmlFor="hlw-email" className="font-label text-xs text-background-50/90">
                    邮箱地址
                  </label>
                  <input
                    id="hlw-email"
                    type="email"
                    name="email"
                    required
                    placeholder="you@example.com"
                    className="w-full rounded-md border border-background-50/30 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-background-50"
                  />
                </div>

                <input
                  type="text"
                  name="contact_alt"
                  className="aux-note-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />

                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="mt-1 inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 disabled:cursor-not-allowed disabled:opacity-70"
                >
                  <i className={status === 'loading' ? 'ri-loader-4-line text-base' : 'ri-send-plane-line text-base'} />
                  {status === 'loading' ? '提交中…' : '订阅速递'}
                </button>

                {status === 'error' && formError ? (
                  <p className="flex items-start gap-2 rounded-md bg-background-50 px-3 py-2.5 text-xs leading-relaxed text-primary-700">
                    <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center">
                      <i className="ri-error-warning-line text-sm" />
                    </span>
                    {formError}
                  </p>
                ) : null}
              </form>
            )}

            <p className="mt-4 text-[11px] leading-relaxed text-background-50/70">
              本站为内容展示站点，提交内容仅用于速递发送。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}